<div class="container-fluid">
    <div class="row vistaEscritorio">
        <div class="col-3">
            <div class="container-step">
                <span>Nominación</span>
                <img [attr.src]="step === 1 ? 'assets/img/icon/puntoActivo.svg' : 'assets/img/icon/punto.svg'"
                    alt="Nominacion">
            </div>
        </div>
        <div class="col-3">
            <div class="container-step">
                <span>Trayectoria</span>
                <img [attr.src]="step === 2 ? 'assets/img/icon/puntoActivo.svg' : 'assets/img/icon/punto.svg'"
                    alt="Nominacion">
            </div>
        </div>
        <div class="col-3">
            <div class="container-step">
                <span>Contacto</span>
                <img [attr.src]="step === 3 ? 'assets/img/icon/puntoActivo.svg' : 'assets/img/icon/punto.svg'"
                    alt="Nominacion">
            </div>
        </div>
        <div class="col-3">
            <div class="container-step">
                <span>Confirmación</span>
                <img [attr.src]="step === 4 ? 'assets/img/icon/puntoActivo.svg' : 'assets/img/icon/punto.svg'"
                    alt="Nominacion">
            </div>
        </div>
    </div>
    <div class="row vistaMobile" style="color: #183273">
        <div class="col-12">
            {{step}} de 4 Nominación
        </div>
    </div>
</div>